// extracted by mini-css-extract-plugin
export default {"containerFavs":"Favorites_containerFavs__TFAjr","sinFavs":"Favorites_sinFavs__LpUl8"};